export default __webpack_public_path__ + "static/media/Animals_33.2cb48293.png";